import { render } from "./html-chapter-2.vue?vue&type=template&id=188fd1bf"
import script from "./html-chapter-2.vue?vue&type=script&lang=js"
export * from "./html-chapter-2.vue?vue&type=script&lang=js"

import "./html-chapter-2.vue?vue&type=style&index=0&id=188fd1bf&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__